import {
  NgClass,
  NgFor,
  NgIf,
  NgOptimizedImage,
  NgStyle,
} from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { Product } from 'src/app/classes/utility';
import { CarouselComponent } from 'src/app/components/carousel/carousel.component';
import { ProductService } from '../../product.service';

@Component({
    selector: 'app-image-carousel',
    imports: [CarouselComponent, NgIf, NgOptimizedImage, NgFor, NgStyle, NgClass],
    templateUrl: './image-carousel.component.html',
    styleUrl: './image-carousel.component.scss'
})
export class ImageCarouselComponent implements OnChanges {
  @Input() product!: Product;
  options = {
    0: { slides: 1, nav: false },
  };
  _scrollTo = 0;
  _sleeve: any | undefined;

  constructor(private productService: ProductService) {
    this.productService.sleeveObservable.subscribe((data) => {
      this._sleeve = data;
    });
  }

  ngOnChanges() {
    this._scrollTo = 0;
  }

  scrollTo(i: number) {
    this._scrollTo = structuredClone(i);
  }
}
